export const POSAmexPaymentsStoreSymbol = Symbol('POSAmexPaymentsStore')
export const POSAmexPaymentsTabsStoreSymbol = Symbol('POSAmexPaymentsTabsStore')
export const POSAmexPaymentsFilterStoreSymbol = Symbol('POSAmexPaymentsFilterStore')
export const POSAmexPaymentsStatusSelectStoreSymbol = Symbol('POSAmexPaymentsStatusSelectStore')
export const POSAmexPaymentsRangePickerStoreSymbol = Symbol('POSAmexPaymentsRangePickerStore')
export const POSAmexPaymentsPaginationStoreSymbol = Symbol('POSAmexPaymentsPaginationStore')
export const POSAmexPaymentsDrawerStoreSymbol = Symbol('POSAmexPaymentsDrawerStore')
export const POSAmexPaymentsExportsStoreSymbol = Symbol('POSAmexPaymentsExportsStore')
